export enum ManudalValidation {
    TRAM = 'TRAM',
    GESTOR = 'GESTOR'
}
